const orderStatus = {
  dispatched: {
    text: 'dispatchedOrder',
    color: 'green',
  },
  packing: {
    text: 'packingOrder',
    color: 'yellow',
  },
  packing_and_printing: {
    text: 'packingAndPrintingOrder',
    color: 'yellow',
  },
  printing: {
    text: 'printingOrder',
    color: 'yellow',
  },
  purchased: {
    text: 'purchasedOrder',
    color: 'yellow',
  },
  cancelled: {
    text: 'cancelledOrder',
    color: 'red',
  },
  unknown: {
    text: 'unknownOrder',
    color: 'red',
  },
  ready_to_collect: {
    text: 'collectionReadyOrder',
    color: 'yellow',
  },
  returned_to_warehouse: {
    text: 'returnedOrder',
    color: 'yellow',
  },
  collected: {
    text: 'collectedOrder',
    color: 'green',
  },
  part_dispatched: {
    text: 'partDispatchedOrder',
    color: 'yellow',
  },
  part_ready: {
    text: 'partReady',
    color: 'yellow',
  },
  reprinting: {
    text: 'reprintingOrder',
    color: 'yellow',
  },
  completed: {
    text: 'completedOrder',
    color: 'green',
  },
};

export default orderStatus;
